/* eslint-disable no-console */
<template>
  <div>
    <headerCustom></headerCustom>
    <div class="template main-content sidenav-part ng-scope">
      <div class="d-flex">
        <div class="mx-3">
          <div class="heading-sec">
            <div class="row">
              <div class="col-md-4 column">
                <div class="heading-profile">
                  <h3>Hotel</h3>
                </div>
              </div>
            </div>
          </div>
          <!-- Top Bar Chart -->
          <div class="panel-content">
            <div class="row">
              <div class="col-md-12">
                <div class="widget">
                  <div class="table-area">
                    <div class="widget-title">
                      <div class="float-right">
                        <form class="search-form mr-form">
                          <input
                            type="text"
                            class="form-control"
                            v-model="searchText"
                            @input="viewLogsList(1)"
                            placeholder="Search Here..."
                          />
                        </form>
                      </div>
                      <h3>
                        List of Transactions
                        <span class="tableTotal">(Total : {{ totalCount }})</span>
                      </h3>
                    </div>
                    <div class="table-responsive">
                      <table class="table">
                        <thead>
                          <tr>
                            <th>#</th>
                            <th>Name</th>
                            <th>hotel UniqueId</th>
                            <th>Phone</th>
                            <th>Access Level</th>
                            <th>City</th>
                            <th>State</th>
                            <th>Country</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="(logs, index) in log" v-bind:key="logs._id">
                            <td>{{ index + 1 + (page - 1) * 10 }}</td>

                            <td>
                              <div>{{ logs.description }}</div>
                            </td>
                            <td>
                              <div>{{ logs.logDate | dateFormate }}</div>
                            </td>
                            <td>
                              <div>{{ logs.user.firstName | firstLaterCapital }}</div>
                            </td>
                            <td>
                              <div>{{ logs.meeting.title | capitalize }}</div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                    <!-- <div
                      class="table-body-contents text-center m-3
                        font-size-md font-weight-bold text-muted"
                      v-if="log.length === 0"
                    >No Data Found</div>
                    <div class="text-center" v-if="log.length >= 1">
                      <b-pagination
                        class="mb-0 float-right"
                        v-model="page"
                        align="center"
                        :total-rows="totalCount"
                        :per-page="formData.limit"
                        @input="viewLogsList(page)"
                      />
                    </div> -->
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <sideMenu :navigations="navigation" />
      </div>
    </div>
  </div>
</template>

<script>
import headerCustom from "@/components/Header.vue";
import sideMenu from "@/components/subheader.vue";
import apiservice from "@/service/apiservice";

export default {
  components: {
    headerCustom,
    sideMenu
  },
  data() {
    return {
      navigation: {},
      menu: [
        {
          name: "hotel details",
          path: "/hotel/"
        },
        {
          name: "Transaction",
          path: "/transaction-details/"
        }
      ],
      totalItems: 0,
      id: "",
      logs: {
        idToDelete: ""
      },
      currentPage: 1,
      searchText: "",
      log: [],
      page: 1,
      formData: { limit: 10 },
      totalCount: 0,
      perPage: 10,
      errors: [],
      data: ""
    };
  },
  created() {
    this.navigation._id = this.$route.params.id;
    this.navigation.menu = this.menu;
    this.viewLogsList(this.page);
  },
  methods: {
    viewLogsList(pageNo) {
      this.log = [];
      this.formData.page = pageNo;
      this.formData.limit = this.perPage;
      this.formData.search = this.searchText;
      apiservice.logListPagination(this.formData, data => {
        if (data.code === 200) {
          this.log = data.data.result;

          this.totalCount = data.data.count;
        } else {
        }
      });
    }
  }
};
</script>
